import React from "react";
import { MESSAGE } from "constants/Message";

class MessageText extends React.Component {
  render() {
    const { msg } = this.props;

    if (!msg || msg.length === 0) {
      return null;
    }

    return (
      <>
        {msg && msg.length > 0 && (
          <div
            className={`rounded w-full overflow-y-auto px-4 py-2 text-lg font-semibold ${
              msg[1] === MESSAGE.ERROR
                ? "bg-red-200 text-red-700"
                : "bg-green-200 text-green-700"
            }`}
            style={{ maxHeight: "100px" }}
          >
            {msg[0]}
          </div>
        )}
      </>
    );
  }
}

export default MessageText;
